import React, { useEffect, useRef, useState } from "react";
import {
  ModalBackground,
  ModalContainer,
  ModalContent,
  ModalContentFade,
} from "./ModalTemplate.styles.js";

const Modal = ({
  isOpen,
  children,
  width,
  maxWidth,
  height,
  hideScroll,
  fade,
  onClose,
  radius,
  padding,
  offCloseOnESC,
  offCloseOnOutSideClick,
}) => {
  const [isVisible, setIsVisible] = useState(isOpen);
  const modalRef = useRef(null);

  useEffect(() => {
    let timer;
    if (isOpen) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 250);
    }

    return () => clearTimeout(timer);
  }, [isOpen]);

  useEffect(() => {
    if (isVisible) {
      document.documentElement.style.overflowY = "hidden";
      document.documentElement.style.paddingRight = "8px";
      !hideScroll && window.scrollTo(0, 0);
    } else {
      document.documentElement.style.overflowY = "scroll";
      document.documentElement.style.paddingRight = "0px";
    }
  }, [isVisible, hideScroll]);

  const handleClickOutside = (e) => {
    if (
      modalRef.current &&
      !modalRef.current.contains(e.target) &&
      !offCloseOnOutSideClick
    ) {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape" && !offCloseOnESC) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("click", handleClickOutside);
    };
  }, [handleKeyDown]);

  return (
    isVisible &&
    (fade ? (
      <ModalBackground $open={isOpen}>
        <ModalContainer $center>
          <ModalContentFade
            ref={modalRef}
            $open={isOpen}
            style={{
              height: height,
              width: width,
              padding: padding,
              maxWidth: maxWidth,
              borderRadius: radius,
            }}
          >
            {children}
          </ModalContentFade>
        </ModalContainer>
      </ModalBackground>
    ) : (
      <ModalBackground $open={isOpen}>
        <ModalContainer>
          <ModalContent
            ref={modalRef}
            $open={isOpen}
            style={{
              height: height,
              width: width,
              maxWidth: maxWidth,
              borderRadius: radius,
            }}
          >
            {children}
          </ModalContent>
        </ModalContainer>
      </ModalBackground>
    ))
  );
};

export default Modal;
